module.exports = __webpack_public_path__ + "img/dl.71f915e0.svg";